var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpark(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24268_11287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.432938 4.5546C1.82721 5.01992 2.93768 6.12954 3.40045 7.52296C3.48652 7.78119 3.72771 7.9559 4.00043 7.9559C4.27314 7.9559 4.51348 7.78204 4.60041 7.52296C5.06403 6.12869 6.17364 5.01992 7.56791 4.5546C7.82614 4.46852 8 4.22734 8 3.95547C8 3.68361 7.82614 3.44242 7.56706 3.35549C6.17279 2.89187 5.06403 1.78225 4.59955 0.387983C4.42655 -0.129328 3.5726 -0.129328 3.40045 0.387983C2.93683 1.78225 1.82721 2.89102 0.432938 3.35549C0.174709 3.44157 0 3.68275 0 3.95547C0.000852242 4.22734 0.174709 4.46852 0.432938 4.5546Z",
    fill: "#FF3F97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24268_11287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark);
export default __webpack_public_path__ + "static/media/spark.cb78abbc.svg";
export { ForwardRef as ReactComponent };